import { Page } from '@/core/architecture'

import { UserTradeDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * UserTradeDetail Page
 * Implemented as a practical sample.
 */
export const UserTradeDetail: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <UserTradeDetailTemplate state={state} onFetchMore={actions.onFetchMore} />
  )
}
